import { useHistory, useLocation } from 'react-router-dom';

export const useQueryState = () => {
  const history = useHistory();
  const location = useLocation();

  const updateParams = (params, appendQueryParam = true) => {
    // Parse the existing query parameters
    const queryParams = appendQueryParam
      ? new URLSearchParams(location.search)
      : new URLSearchParams();

    // Update or add each parameter
    Object.entries(params).forEach(([paramName, paramValue]) => {
      queryParams.set(paramName, paramValue);
    });

    // Construct the new URL with updated query parameters
    const newUrl = `${location.pathname}?${queryParams.toString()}`;

    // Update the URL without navigating
    history.replace(newUrl);
  };

  const queryParams = new URLSearchParams(location.search);
  const urlParams = {};
  for (const [key, value] of queryParams.entries()) {
    urlParams[key] = value;
  }

  return { updateParams, queryParams: urlParams, location, history };
};
